import moment from 'moment'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'

// AdapterMoment builds the weekday header from the global moment locale but the day grid from the
// adapter locale, so the header and the dates can start on different days. Use the adapter locale for both.
export class EFAdapterMoment extends AdapterMoment {
  getWeekdays = () => {
    const localeData = moment.localeData(this.getCurrentLocaleCode())
    const weekdays = localeData.weekdaysShort()
    const firstDayOfWeek = localeData.firstDayOfWeek()
    return [...weekdays.slice(firstDayOfWeek), ...weekdays.slice(0, firstDayOfWeek)]
  }
}
